<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>查理任务区域管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="ID"
                        prop="id">
            <el-input placeholder="请输入ID"
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="名称"
                        prop="keyword">
            <el-input placeholder="请输入关键字"
                      v-model="search.keyword"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/clb-product-area/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="名称"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="225">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/clb-product-category/table?prod_classid=${scope.row.id}`">
                <el-button size="mini">分类列表</el-button>
              </router-link>
              <router-link :to="`/clb-product-area/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">编辑
                </el-button>
              </router-link>
              <el-button type="danger"
                         size="mini"
                         @click="onDelete(scope.$index, table)">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../clb-product-area.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        keyword: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: '查理任务区域ID',
        },
        {
          key: 'name',
          text: '查理任务区域名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getClbProductAreaTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteClbProductAreaData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/clb-product-area/pages/ClbProductAreaTable.vue